const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/Medication/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        noImage: 'Kein Bild vorhanden',
        currentMedis: 'Aktuell gültige Medikamente',
        medicationTitle: 'Medikamente',
    },
    __RELATIVE_SOURCE_FILE__
);
